module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_photogallery_2.00b9c28a.jpg";